<template>
    <Loading :inset="true" :loading="loading">
        <div v-if="giftCodeRedeemed" class="max-w-3xl mx-auto p-0 mt-6 lg:mt-0 lg:p-4">
            <div class="max-w-3xl mx-auto mt-12 p-8">
                <div class="text-center space-y-4">
                    <h1 class="text-3xl font-bold text-green-700">🎉 Geschenkcode erfolgreich eingelöst!</h1>

                    <p v-if="giftMessage" class="text-lg text-green-800 font-medium">
                        {{ giftMessage }}
                    </p>

                    <p v-if="newAbo" class="text-xxs text-green-200 font-light">
                        Ihr Geschenk-Abo verlängert sich nicht automatisch und es ist keine Zahlungsart hinterlegt.
                        Wenn Sie Ihr Abo nach Ablauf des Geschenkzeitraums weiter nutzen möchten, hinterlegen Sie bitte eine Zahlungsart und aktivieren Sie das Abo.
                        Bis zum Ende des Geschenkzeitraums entstehen Ihnen keinerlei Kosten.
                    </p>

                    <p v-if="!newAbo" class="text-xxs text-green-200 font-light">
                        Für dieses Produkt besteht bereits ein aktives Abo.
                        Der eingegebene Geschenk-Gutschein wird Ihrem bestehenden Abo automatisch hinten angehängt und verlängert dieses um den entsprechenden Zeitraum.
                        Während des Geschenkzeitraums entstehen Ihnen keine zusätzlichen Kosten.
                        Eine Verlängerung Ihres regulären Abos erfolgt erst, nachdem der angehängte Geschenkzeitraum abgelaufen ist.
                    </p>

                    <div class="pt-6">
                        <router-link class="btn primary bg-blue-dark" to="/dashboard">Weiter zum Dashboard →</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="loggedIn" class="max-w-3xl mx-auto p-0 mt-6 lg:mt-0 lg:p-4">
            <h2 class="text-2xl font-bold mb-4 text-center">Geschenkcode einlösen</h2>
            <p v-if="errorMsg" class="text-red font-bold mb-4 text-center">{{ errorMsg }}</p>
            <div class="bg-white rounded-lg">
                <form @submit.prevent="redeemGiftCode">
                    <div class="p-6">
                        <label for="giftCode" class="block text-sm font-medium text-gray-700 mb-2"> Geben Sie Ihren Geschenkcode ein: </label>
                        <input
                            v-model="giftCode"
                            type="text"
                            id="giftCode"
                            class="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Geschenkcode eingeben"
                            required
                        />
                    </div>
                    <div class="px-6 pb-6">
                        <button type="submit" class="btn primary flex flex-row gap-2 items-center max-w-3xl mx-auto">Einlösen</button>
                    </div>
                </form>
            </div>
        </div>

        <div v-else class="max-w-3xl mx-auto p-0 mt-6 lg:mt-0 lg:p-4">
            <h2 class="text-2xl font-bold mb-4 text-center">Bitte registrieren Sie sich, um Ihren Geschenkcode einzulösen</h2>

            <div v-if="!showLogin" class="">
                <button @click="showLogin = true" class="btn bg-blue-dark text-white mb-12 w-full">Ich habe bereits ein Account</button>
                <CheckoutRegister redirect-to="/geschenk#redeem" :small-layout="true" />
            </div>
            <div v-else>
                <button @click="showLogin = false" class="btn bg-blue-dark text-white mb-12 w-full">Ich habe noch kein Account</button>
                <Login class="text-left" redirect-to="/geschenk#redeem" />
            </div>
        </div>
    </Loading>
</template>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import CheckoutRegister from './checkout/CheckoutRegister.vue';
import Loading from './miscellaneous/Loading.vue';
import Login from './auth/Login.vue';

const store = useStore();

const giftCode = ref('');
const giftMessage = ref('');
const newAbo = ref('');
const errorMsg = ref('');
const loading = ref(true);
const giftCodeRedeemed = ref(false);
const showLogin = ref(false);

const loggedIn = computed(() => store.getters['user/isLoggedIn']);

onMounted(() => {
    loading.value = false;
});

const redeemGiftCode = async () => {
    loading.value = true;
    errorMsg.value = '';

    try {
        const { data } = await axios.post('/api/v1/giftcode/redeem/' + giftCode.value);

        if (data.success) {
            giftMessage.value = data.message;
            newAbo.value = data.newAbo;
            giftCodeRedeemed.value = true;
            giftCode.value = '';
        } else {
            errorMsg.value = data.message || 'Der Geschenkcode ist ungültig.';
        }
    } catch (error) {
        errorMsg.value = error.response?.data?.message || 'Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten.';
    } finally {
        loading.value = false;
    }
};
</script>
